import { render, staticRenderFns } from "./ActForm.vue?vue&type=template&id=b918c97e&"
import script from "./ActForm.vue?vue&type=script&lang=ts&"
export * from "./ActForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports